import {
    GET_USER_DATA, GET_GROUP_DATA,
    SET_LOGIN, SET_POINTS,
    GIFT_POPUP, USER_POPUP, SUBSTRACT_POINTS, GIFT_POPUP_LOADING
} from "./types";

const initialState = {
    id: null,
    name: '',
    username:'',
    image: null,
    isActive: 1,
    group: [],
    isSupportEnabled: 0,
    conditions: '',
    showLink: 0,
    isPartnerEnabled: null,
    showConditionsFirst: 0,
    link: '',
    giftPopup: null,
    giftPopupLoading: null,
    userPopup: null,
    userPopupName: null,
    userPopupLoading: false,
    hasActiveGame: false,
    showLinkInGames: null,
    isLogin: false,
    points: null,
}
export const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_USER_DATA:
            return {
                ...state,
                id: action.payload.id,
                name: action.payload.name,
                image: action.payload.image,
                isActive: action.payload.isActive,
                isSupportEnabled: action.payload.isSupportEnabled,
                conditions: action.payload.conditions,
                showLink: action.payload.showLink,
                isPartnerEnabled: action.payload.isPartnerEnabled,
                showConditionsFirst: action.payload.showConditionsFirst,
                link: action.payload.link,
                hasActiveGame: action.payload.hasActiveGame,
                showLinkInGames: action.payload.showLinkInGames,
            }
        case GET_GROUP_DATA:
            return {
                ...state,
                id: action.payload.id,
                group: action.payload.group,
                isSupportEnabled: action.payload.isSupportEnabled,
                conditions: action.payload.conditions,
                showLink: action.payload.showLink,
                isPartnerEnabled: action.payload.isPartnerEnabled,
                showConditionsFirst: action.payload.showConditionsFirst,
                link: action.payload.link,
                hasActiveGame: action.payload.hasActiveGame,
                showLinkInGames: action.payload.showLinkInGames,
            }
        case GIFT_POPUP:
            return {
                ...state,
                giftPopup: action.payload
            }
        case GIFT_POPUP_LOADING:
            return {
                ...state,
                giftPopupLoading: action.payload
            }
        case SET_LOGIN:
            return {
                ...state,
                isLogin: action.login,
                username: action.username
            }
        case SET_POINTS:
            return {
                ...state,
                points: action.payload
            }
        case SUBSTRACT_POINTS:
            return {
                ...state,
                points: state.points - action.payload
            }
        case USER_POPUP:
            return {
                ...state,
                userPopup: action.payload.userPopup,
                userPopupName: action.payload.userPopupName,
                userPopupLoading: action.payload.userPopupLoading,
            }
        default:
            return state
    }
}